import React from 'react'
import { Drawer, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { Close as CloseIcon } from '@mui/icons-material';

import { RoutesConstants } from '@/main/routes/routesConstants';
import { getTranslateByKey } from '@/main/services/utils';
import logo from '@/main/assets/images/login/xnuup_main_logo_white.png';

import { ISubPagesLinks } from '../header'
import RegisterMenu from '../../registerMenu/registerMenu';
import Translates from '../../translates/translates';
import * as S from './styles';
import * as StylesHeader from '../styles';

interface IHeadermobileProps {
  subPagesLinks: ISubPagesLinks[];
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
}
function Headermobile({
  isMobileMenuOpen,
  toggleMobileMenu,
  subPagesLinks
}: IHeadermobileProps) {

  function onClickAreaSubPage(e: React.MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
  }

  function onClickSubPage() {
    window.scrollTo({ top: 0 });
    toggleMobileMenu();
  }

  if (!isMobileMenuOpen) return <></>;
  return (
    <Drawer
      anchor={'right'}
      open={isMobileMenuOpen}
      onClose={toggleMobileMenu}
    >
      <S.Container onClick={onClickAreaSubPage}>
        <S.AreaLogo>
          <S.Logo
            src={logo}
            onClick={() => toggleMobileMenu()}
          />
        </S.AreaLogo>
        <S.AreaCloseIcon>
          <IconButton
            id='id-homepage-close-header-mobile'
            aria-label="close"
            onClick={() => { toggleMobileMenu() }}
          >
            <CloseIcon />
          </IconButton>
        </S.AreaCloseIcon>
        {subPagesLinks.map((link, index) => (
          <Link
            key={index}
            to={link.url}
            onClick={onClickSubPage}
          >
            <S.SubPage>{link.name}</S.SubPage>
          </Link>
        ))}
        <RegisterMenu />
        <Translates />
        <StylesHeader.Login to={RoutesConstants.login}>
          {getTranslateByKey('information.login')}
        </StylesHeader.Login>
      </S.Container>
    </Drawer >
  )
}

export default Headermobile